"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Text = _interopRequireDefault(require("./Text"));

var Pre =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Pre, _PureComponent);

  function Pre() {
    (0, _classCallCheck2.default)(this, Pre);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Pre).apply(this, arguments));
  }

  (0, _createClass2.default)(Pre, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_Text.default, (0, _extends2.default)({
        is: "pre",
        marginTop: 0,
        marginBottom: 0
      }, this.props));
    }
  }]);
  return Pre;
}(_react.PureComponent);

exports.default = Pre;
Pre.displayName = "Pre";
(0, _defineProperty2.default)(Pre, "propTypes", (0, _objectSpread2.default)({}, _Text.default.propTypes));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy90eXBvZ3JhcGh5L3NyYy9QcmUuanMiXSwibmFtZXMiOlsiUHJlIiwicHJvcHMiLCJQdXJlQ29tcG9uZW50IiwiVGV4dCIsInByb3BUeXBlcyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0lBRXFCQSxHOzs7Ozs7Ozs7Ozs7NkJBS1Y7QUFDUCxhQUFPLDZCQUFDLGFBQUQ7QUFBTSxRQUFBLEVBQUUsRUFBQyxLQUFUO0FBQWUsUUFBQSxTQUFTLEVBQUUsQ0FBMUI7QUFBNkIsUUFBQSxZQUFZLEVBQUU7QUFBM0MsU0FBa0QsS0FBS0MsS0FBdkQsRUFBUDtBQUNEOzs7RUFQOEJDLG9COzs7QUFBWkYsRzs4QkFBQUEsRywrQ0FFZEcsY0FBS0MsUyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBQdXJlQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnXG5pbXBvcnQgVGV4dCBmcm9tICcuL1RleHQnXG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzIFByZSBleHRlbmRzIFB1cmVDb21wb25lbnQge1xuICBzdGF0aWMgcHJvcFR5cGVzID0ge1xuICAgIC4uLlRleHQucHJvcFR5cGVzXG4gIH1cblxuICByZW5kZXIoKSB7XG4gICAgcmV0dXJuIDxUZXh0IGlzPVwicHJlXCIgbWFyZ2luVG9wPXswfSBtYXJnaW5Cb3R0b209ezB9IHsuLi50aGlzLnByb3BzfSAvPlxuICB9XG59XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/typography/src/Pre.js
// module id = 275
// module chunks = 0